import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../screens/header";

function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="page-container bg-home">
      <Header />
      <main className="content-wrapper">
        {children}
      </main>
    </div>
  );
}

export default Layout;
